import { useStoreId } from './use-store-id'

export const useButtonListHref = (): string => {
  const { selectedStoreId } = useStoreId()
  return selectedStoreId ? '/' : '/?nouto'
}
